module.exports = __webpack_public_path__ + "img/baby_6.243203f4.jpg";